import React from "react";
import PropTypes from "prop-types";
// 課金-ADD-START
import i18n from "i18next";
// 課金-ADD-END

import ConfirmDiffContent from "@/react-components/Confirm/DiffContent";

class ConfirmDiffBody extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpand: false,
    };
  }

  render() {
    const {
      title,
      data,
      className,
      showExpand,
      // 課金-ADD-START
      downloadUrl,
      downloadText,
      // 課金-ADD-END
    } = this.props;
    const { isExpand } = this.state;

    return (
      <div className={`confirm-diff-body-container ${className || ""}`}>
        {showExpand ? (
          <button
            // 課金-UPD-START
            className={`confirm-diff-body-container-title${
              !isExpand ? " confirm-diff-body-container-title-expand" : ""
            }${isExpand && downloadUrl ? " margin-bottom" : ""}`}
            // 課金-UPD-END
            onClick={() => this.setState({ isExpand: !isExpand })}
          >
            {title}
            <img
              alt=""
              src={require(`@/assets/images/lp_ic_arrow_${
                isExpand ? "up" : "down"
              }.svg`)}
            />
          </button>
        ) : (
          // 課金-UPD-START
          <div
            className={`confirm-diff-body-container-title${
              downloadUrl ? " margin-bottom" : ""
            }`}
          >
            {title}
          </div>
          // 課金-UPD-END
        )}
        {/* 課金-ADD-START */}
        {(showExpand && isExpand) || !showExpand ? (
          <>
            {downloadUrl ? (
              <a
                className="confirm-diff-body-container-download"
                target="_blank"
                rel="noopener noreferrer"
                href={downloadUrl}
              >
                <img src={require("@/assets/images/download.svg")} alt="" />
                <span
                  dangerouslySetInnerHTML={{
                    __html: downloadText || i18n.t("common_download_title"),
                  }}
                />
              </a>
            ) : null}
            <ConfirmDiffContent data={data} />
          </>
        ) : null}
        {/* 課金-ADD-END */}
      </div>
    );
  }
}

ConfirmDiffBody.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  showExpand: PropTypes.bool,
  // 課金-ADD-START
  downloadText: PropTypes.string,
  downloadUrl: PropTypes.string,
  // 課金-ADD-END
};

ConfirmDiffBody.defaultProps = {
  showExpand: false,
};

export default ConfirmDiffBody;
